/* eslint-disable @next/next/no-img-element */
import { gSP } from "app/blitz-server"
import contentful from "integrations/contentful"

import BlogPost from "app/contentful/BlogPost"

export const getStaticProps = gSP(async function getStaticProps({ params }) {
  const slug = params?.slug as string

  const post = await contentful.getPostBySlug(slug)

  return {
    props: {
      post: {
        ...post,
      },
    },
    revalidate: 10,
  }
})

export async function getStaticPaths() {
  const slugs = await contentful.getPostSlugs()

  return {
    paths: slugs.map((slug) => {
      return {
        params: {
          slug,
        },
      }
    }),
    fallback: "blocking",
  }
}

export default BlogPost
